import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_requires_use_contraceptives_other_forms_birth_control_1'

export const dataPointDefinition = {
  retracedId: 'facility_requires_use_contraceptives_other_forms_birth_control_1',
  name: 'Facility requires the use of contraceptives or other forms of birth control at hiring',
  description:
    'Select this option if the facility requires that any workers begin to use (or continue to use) contraceptives or other forms of birth control as part of the hiring process. ',
  meta: {
    slcpMeta: {
      key: 'disc-3-4x',
      number: 'RH-DIS-5-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-3-4x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26560,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
